import type { InternalLabel } from '@ulysses-inc/harami_api_client'
import { createContext, type FC, type ReactNode, useContext } from 'react'
import { useLabelForm } from './useLabelForm'

type LabelFormContextValue = ReturnType<typeof useLabelForm>

const LabelFormContext = createContext<LabelFormContextValue | null>(null)

export const useLabelFormContext = (): LabelFormContextValue => {
  const ctx = useContext(LabelFormContext)
  if (!ctx) {
    throw new Error('useLabelFormContext must be used within LabelFormProvider')
  }
  return ctx
}

type Props = {
  label: InternalLabel
  labelMasterId: string
  onClose: () => void
  children: ReactNode
}

export const LabelFormProvider: FC<Props> = ({
  label,
  labelMasterId,
  onClose,
  children,
}) => {
  const value = useLabelForm({ label, labelMasterId, onClose })
  return (
    <LabelFormContext.Provider value={value}>
      {children}
    </LabelFormContext.Provider>
  )
}
